import React from 'react';
import PropTypes from 'prop-types';
import { pageTitleShape, injectPageTitle } from '../../providers/PageTitleProvider';
import './styles.css';

const PageCaption = ({ className, pageTitle }) => (
  <div styleName="pageCaption" className={className}>
    <div className="hidden-mobile" styleName="pageTitle">
      {pageTitle.title}
    </div>
    <div
      className="hidden-computer hidden-tablet"
      styleName="pageTitle"
    >
      {pageTitle.shortTitle || pageTitle.title}
    </div>
  </div>
);
PageCaption.propTypes = {
  className: PropTypes.string,
  pageTitle: pageTitleShape,
};

export default injectPageTitle(PageCaption);
